export const removeWhitespaces = (text: any) => {
  if (typeof text === 'string') {
    return text.replace(/ /g, '');
  }
  return text;
};
